import type { AxiosError } from "axios";

import {
  sendMessageToReactNativeWebView,
  WEB_VIEW_ACTIONS,
} from "@/shared/lib";
import { privateAPI } from "@/shared/lib/axios";
import { authStore } from "@/shared/stores";
import { memoizedRefreshToken } from "./refresh-token";

export const errorResponse = async (error: AxiosError) => {
  const config = error?.config;

  if (error?.response?.status === 401) {
    const refreshWasSuccessful = await memoizedRefreshToken();
    if (refreshWasSuccessful) {
      const refreshedToken = authStore.getToken();

      return privateAPI({
        ...config,
        headers: { Authorization: `Bearer ${refreshedToken}` },
      });
    } else {
      sendMessageToReactNativeWebView({ type: WEB_VIEW_ACTIONS.LOGOUT });
      authStore.setToken(null);
      window.location.href = "/login";
    }
  }
  return Promise.reject(error);
};
